import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Headers from './Layouts/Headers';
import Footers from './Layouts/Footers';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
class Home extends Component {

	componentDidMount() {
		//remove loader
		document.getElementById("LoadingModal").style.display = "none";
	}
	render() {
		return (
			<div>
				<Headers></Headers>
				<section className="service-area more-top-padding" id="services">
					<div className="container more-top-padding">
						<div className="row">
							<div className="col-xs-12">

							</div>
						</div><br /><br />
						<div className="row space-evenly overflow-scroll wow bounceInUp" data-wow-duration="1.2s" data-wow-delay="1.2s">
							<div className="">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										
									</div>
									<h3><a href="/input/patient/details"> New Patient Details </a> </h3>
									<p>
										Here, Enter all the required details for a new Patient
									</p>
								</div> */}

								<a className="navbar-brand" href='/input/patient/details'>
									<Card className="dashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													New Patient Details
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>
													Here, Enter all the required details for a new Patient
												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>

							<div className="">
								<a className="navbar-brand" href='/search/patient'>
									<Card className="dashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-search icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>
											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Search Patient Details
												</Typography>
												<Typography gutterBottom variant="p" component="div" align='center' paragraph="true" className='innerdashcardsp'>
													Efficient way to look for patient <br /> details
												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>


							</div>
							<div className="">
								<a className="navbar-brand" href='/confirm/patient'>
									<Card className="dashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-user icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>
											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Confirm Patient
												</Typography>
												<Typography gutterBottom variant="p" component="div" align='center' paragraph="true" className='innerdashcardsp'>
													Efficient way to look for patient <br /> details
												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>


							</div>
							<div className="">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
								
									</div>
									<h3><a href="">Billing</a></h3>
									<p>
										Enter Transaction and give ticket
									</p>
								</div> */}
								{/* <a className="navbar-brand" href="/get/bill/ticket">
									<Card className="dashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-dollar icons icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>
											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Billing
												</Typography>
												<Typography gutterBottom variant="p" component="div" align='center' paragraph="true" className='innerdashcardsp'>
													Enter Transaction and give ticket
												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a> */}
							</div>

						</div>
					</div>
				</section>
				<Footers></Footers>
			</div>
		)
	}
}

export default Home
